import { Platform } from 'react-native';

const sansFont = Platform.OS === 'web' ? '"Plus Jakarta Sans", system-ui, sans-serif' : undefined;

export const typography = {
  titleXL: {
    fontSize: 28,
    fontWeight: '700' as const,
    letterSpacing: 0.3,
    fontFamily: sansFont,
  },
  titleLg: {
    fontSize: 22,
    fontWeight: '600' as const,
    fontFamily: sansFont,
  },
  title3: {
    fontSize: 18,
    fontWeight: '600' as const,
    letterSpacing: 0.2,
    fontFamily: sansFont,
  },
  body: {
    fontSize: 16,
    fontWeight: '400' as const,
    fontFamily: sansFont,
  },
  caption: {
    fontSize: 13,
    fontWeight: '400' as const,
    letterSpacing: 0.2,
    fontFamily: sansFont,
  },
  button: {
    fontSize: 16,
    fontWeight: '600' as const,
    letterSpacing: 0.5,
    fontFamily: sansFont,
  },
};
